import type { HolderFilter, HolderSortColumn, HoldersPeriodId } from './types';

export type SetPeriodAction = { type: 'SET_PERIOD'; periodId: HoldersPeriodId };
export const setPeriod = (periodId: HoldersPeriodId): SetPeriodAction => ({ type: 'SET_PERIOD', periodId });

export type SetFilterAction = { type: 'SET_FILTER'; filter: HolderFilter };
export const setFilter = (filter: HolderFilter): SetFilterAction => ({ type: 'SET_FILTER', filter });

export type SetSearchAction = { type: 'SET_SEARCH'; search: string };
export const setSearch = (search: string): SetSearchAction => ({ type: 'SET_SEARCH', search });

export type SetSortAction = { type: 'SET_SORT'; column: HolderSortColumn };
export const setSort = (column: HolderSortColumn): SetSortAction => ({ type: 'SET_SORT', column });

export type HoldersAction = SetPeriodAction | SetFilterAction | SetSearchAction | SetSortAction;
